import { EmmaFactory } from '@axa-asia/hk-emma-js';
import jwtDecode from 'jwt-decode';
import config from '../config';
import { checkLoginIsApp } from '../server/utils/helpers';
import { getLocaleLanguageValue } from './helpers';
import { ROUTE_NAMES } from '../constants/constants';
import { browserHistory } from 'react-router';

function getLanguage() {
  return window.location.pathname.split('/').find(s => !!s) || 'en';
}

export function getPolicyType() {
  // eslint-disable-next-line no-restricted-syntax
  for (const policyType in ROUTE_NAMES) {
    if (window.location.pathname.includes(ROUTE_NAMES[policyType])) {
      return policyType;
    }
  }

  return undefined;
}

export function getUserEmailByJwtToken() {
  const jwtToken = sessionStorage.getItem('token');
  let decodedJwtToken = {};
  let loginId = '';
  if (jwtToken) {
    decodedJwtToken = jwtDecode(jwtToken);
  }
  if (decodedJwtToken && typeof decodedJwtToken === 'object') {
    ({ loginId } = decodedJwtToken);
  }
  return loginId;
}

export function getAxaIdByJwtToken() {
  let axaId = '';
  try {
    const jwtToken = sessionStorage.getItem('token');
    let decodedJwtToken = {};
    
    if (jwtToken) {
      decodedJwtToken = jwtDecode(jwtToken);
    }
    if (decodedJwtToken && typeof decodedJwtToken === 'object') {
      axaId = decodedJwtToken.sub;
    }
    return axaId;
  } catch (error) {
    console.error(error);
    return axaId;
  }
}

export const stringFormatter = (template, name) => {
  let result = template;
  // eslint-disable-next-line no-template-curly-in-string
  // eslint-disable-next-line quotes
  result = result
    .replace(`\${redirectUri}`, name)
    .replace(`\${language}`, getLanguage());
  return result;
};

export const getSignInUrl = (Url, signInRedirectUrl) => {
  const redirectUri = encodeURIComponent(signInRedirectUrl);
  return stringFormatter(Url, redirectUri);
};

export function goToSignIn() {
  const isApp = checkLoginIsApp();
  const signInUrl = isApp ? config.signInAppUrl : config.signInUrl;
  const signInRedirectUrl = isApp
    ? config.signInAppRedirectUrl
    : config.signInRedirectUrl;
  const Url = getSignInUrl(signInUrl, signInRedirectUrl);
  const token = getAxaIdByJwtToken();
  if (isApp) {
    const lang = getLanguage();
    const title = getLocaleLanguageValue('common.login.title', lang || 'en');
    EmmaFactory.createInstance()
      .then(p => {
        p.instance.setNavigationTitle(title);
        window.top.location.href = Url;
        // p.instance.navClose();
        p.instance.hideBackButton();
      })
      .catch(() => {});
  } else if (token) {
    // find my policy which with token
    const signOutUrl = `${
      config.loginPageBaseDomain
    }/en/emma/home/emma-common/signOut?redirectUrl=${encodeURIComponent(Url)}`;
    window.top.location.href = signOutUrl;
  } else {
    window.top.location.href = Url;
  }
}

export function goToSignInAfterSignOut() {
  EmmaFactory.createInstance().then(e => {
    e.instance.logout();
  });
  goToSignIn();
}

export function goToPreLoginSettings() {
  EmmaFactory.createInstance().then(e => {
    e.instance.goTo('emma-login/preLoginProfile');
  });
}

export const browserHistoryGoto = (s, mode) => {
  const route = location.href.indexOf('/chatbot/') >= 0 ? '/chatbot' : '';
  if (s.startsWith('/')) s = s.substring(1, s.length);

  if (mode === 'REPLACE') {
    browserHistory.replace(`${route}/${s}`);
  } else {
    browserHistory.push(`${route}/${s}`);
  }
};
